class PredictiveSearch extends HTMLElement {
    constructor() {
        super();

        this.input = this.querySelector('input[type="search"]');
        this.predictiveSearchResults = this.querySelector('#predictiveSearchSection');

        // Set the current blog handle (e.g., "returns-refunds")
        this.currentBlogHandle = this.getAttribute('data-blog-handle');

        this.input.addEventListener(
            'input',
            this.debounce((event) => {
                this.onChange(event);
            }, 300).bind(this)
        );
    }

    onChange() {
        const searchTerm = this.input.value.trim();

        if (!searchTerm.length) {
            this.close();
            return;related-articles__wrapper
        }

        this.getSearchResults(searchTerm);
    }

    getSearchResults(searchTerm) {
        // var url= `/search/suggest?q=${searchTerm}&resources[type]=article&resources[blog]=${this.currentBlogHandle}`;
        // const blogHandle = 'returns-refunds'; 
        console.log(this.currentBlogHandle); 
        $.ajax({
            url: `/search/suggest?q=${searchTerm}&resources[type]=article&resources[blog]=${this.currentBlogHandle}&section_id=predictive-search`,
            method: 'GET',
            success: (response) => {
                const resultMarkup = $(new DOMParser().parseFromString(response, 'text/html'))
                    .find('#predictiveSearchSection')
                    .html();
    
                if (resultMarkup) {
                    this.predictiveSearchResults.innerHTML = resultMarkup;
                    this.open();
                } else {
                    this.predictiveSearchResults.innerHTML = '<p>No articles found in this blog!</p>';
                }
            },
            error: () => {
                this.close();
            },
        });
    }
    
    open() {
        this.predictiveSearchResults.style.display = 'block';
    }

    close() {
        this.predictiveSearchResults.style.display = 'none';
    }

    debounce(fn, wait) {
        let t;
        return (...args) => {
            clearTimeout(t);
            t = setTimeout(() => fn.apply(this, args), wait);
        };
    }
}

customElements.define('predictive-search', PredictiveSearch);























